// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sn7rv6B2u7u13g {
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 12px;
  gap: var(--ds-space-050, 4px);
}
.sn7rv6B2u7u13g a {
  display: grid;
  grid-template-columns: auto 1fr auto;
  flex: 1;
  align-items: center;
  text-decoration: none;
  gap: var(--ds-space-050, 4px);
}
.PGfMeczN6jLKAP {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, ""]);
// Exports
export var externalLink = `sn7rv6B2u7u13g`;
export var linkText = `PGfMeczN6jLKAP`;
export default ___CSS_LOADER_EXPORT___;
